<template>
    <div>
        <ValidationObserver v-slot="{ invalid }" ref="observer">
            <b-form role="form" class="mt-4">
                <b-row>
                    <b-col cols="8">
                        <b-table-simple bordered responsive class="border-dark">
                            <b-thead class="text-center">
                                <b-tr class="bg-grey">
                                    <b-th>Revenue Point Type</b-th>
                                    <b-th>Divide Settings (%)</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr class="input-row">
                                    <b-td>Direct Payout</b-td>
                                    <b-td class="px-0">
                                        <b-input-group append="%">
                                            <b-form-input type="text" v-model="form.direct_payout_percentage" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                                <b-tr class="input-row">
                                    <b-td>Pool Rewards</b-td>
                                    <b-td class="px-0">
                                        <b-input-group append="%">
                                            <b-form-input type="text" v-model="form.pool_payout_percentage" @keydown="preventNonNumericInput"></b-form-input>
                                        </b-input-group>
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                    <b-col cols="8">
                        <b-button block variant="primary" class="w-50" @click.prevent="update" :disabled="invalid">Save</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </ValidationObserver>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import {
notifyFunctionMixin,
axios,
services,
getHeader,
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import { useHubStore } from '@/stores/hubStore'
import { EventBus } from "@/main";

export default {
    mixins:[
        notifyFunctionMixin,
    ],
    components: {
        ValidationObserver,
        ValidationProvider,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
    },
    watch: {
        form: {
            handler(newValue) {
            },
            deep:true,
        },
    },
    data() {
        return {
            hub_team_member_kpi_id: null,
            form: {
                revenue_distribution_setting_id: null,
                hub_id: null,
                direct_payout_percentage: null,
                pool_payout_percentage: null,
            },
        };
    },
    computed: {
        ...mapState(useHubStore,['current_hub', 'current_team'])
    },
    created() {
        this.getRevenueDistributionSetting();
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        getRevenueDistributionSetting() {
            if(this.$route.params.hub_id)
            {
                this.form.hub_id = this.current_hub.hub_id;
            }
            else if(this.$route.params.hub_team_id)
            {
                this.form.hub_id = this.current_team.hub.hub_id;
            }

            axios.get(services.hub + 'hub_comms/revenue_distribution_setting/' + this.form.hub_id, {headers: getHeader()})
            .then(res => {
                if(res.data.data.length > 0)
                {
                    this.form = res.data.data[0];
                }
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        update() {
            for (let key in this.form) {
                this.form[key] = parseFloat(this.form[key]);
            }
            const postData = this.form;

            if(this.form.revenue_distribution_setting_id)
            {
                axios.put(services.hub + 'hub_comms/revenue_distribution_setting/' + this.form.revenue_distribution_setting_id, postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Revenue Distribution Setting </b> - Successfully Updated.')
                        this.getRevenueDistributionSetting()
                        EventBus.$emit('refetch-payout-settings');
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }
            else
            {
                axios.post(services.hub + 'hub_comms/revenue_distribution_setting', postData, {headers: getHeader()})
                .then(res => {
                    if(res.status == 200)
                    {
                        this.notifySuccess('<b>Hub Revenue Distribution Setting </b> - Successfully Created.')
                        this.getRevenueDistributionSetting();
                        EventBus.$emit('refetch-payout-settings');
                    }
                })
                .catch(e => {
                    this.errorFunction(e)
                })
            }

        },
    }
}
</script>